// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-header-container-XdTdS {
  height: 52px;
  align-items: center;
  text-align: start;
}

.table-header-tab-oZi_c {
  position: sticky;
  top: 0;
  text-align: start;
  padding: 0px 26px;
  border-bottom: 1px solid var(--border-color);
  background-color: white;
  z-index: 1;
  transition: transform 200ms;
}

.table-header-hiddenHeader-CIJrr {
  transform: translateY(-100%);
}

.table-header-tab-oZi_c:first-child {
  padding-left: 0px;
}

.table-header-tab-oZi_c:last-child {
  width: 100%;
  padding-right: 0px;
}

.table-header-cellContent-yqFJV {
  font-size: 15px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  white-space: nowrap;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/table-header/table-header.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,iBAAiB;EACjB,4CAA4C;EAC5C,uBAAuB;EACvB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".container {\n  height: 52px;\n  align-items: center;\n  text-align: start;\n}\n\n.tab {\n  position: sticky;\n  top: 0;\n  text-align: start;\n  padding: 0px 26px;\n  border-bottom: 1px solid var(--border-color);\n  background-color: white;\n  z-index: 1;\n  transition: transform 200ms;\n}\n\n.hiddenHeader {\n  transform: translateY(-100%);\n}\n\n.tab:first-child {\n  padding-left: 0px;\n}\n\n.tab:last-child {\n  width: 100%;\n  padding-right: 0px;\n}\n\n.cellContent {\n  font-size: 15px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.85);\n  white-space: nowrap;\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `table-header-container-XdTdS`,
	"tab": `table-header-tab-oZi_c`,
	"hiddenHeader": `table-header-hiddenHeader-CIJrr`,
	"cellContent": `table-header-cellContent-yqFJV`
};
export default ___CSS_LOADER_EXPORT___;
